module.exports = __webpack_public_path__ + "static/media/imagem27.aa015378.jpeg";